import React from 'react'
import AdminHistoryTable from '../../../../shared/DataTable/AdminHistoryTable'

const AdminHistory = () => {
    return (
        <div className='p-6'>
            <AdminHistoryTable/>
        </div>
    )
}

export default AdminHistory